<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='despachos' :items='despachos' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar.head-toolbar-ldespacho(flat color='teal lighten-1' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Despachos
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Busqueda' single-line hide-details color='teal darken-4')
            v-spacer
            LiquidacionM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :formPadre='editedItem' @save='listarDespacho' tipo='liquidacion')

        template(v-slot:item.action='{ item }')
          v-tooltip(v-if='item.estatus === "CERRADO" ' bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(v-else bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='red' @click='editItem(item,false)' v-on="on") mdi-tank
            | Liquidar
        template(v-slot:no-data)
          h1 No hay Despacho Pendientes
</template>

<script>
import Api from '@/services/methods'
import LiquidacionM from '../components/modals/LiquidacionM'
export default {
  name: 'LiquidacionDespacho',
  data: () => ({
    expanded: [],
    page: -1,
    listProductos: false,
    arrayListProductos: [],
    motivo: ['No hay Devolucion', 'Devolucion Parcial', 'Devolucion Total'],
    loadinghijo: true,
    dialog: false,
    read: false,
    emp: false,
    veh: false,
    chofer: null,
    loading: true,
    headers: [
      { text: 'Fecha Registro', value: 'idDespacho.fechaCarga' },
      { text: 'Chofer', value: 'idChofer.nombre' },
      { text: 'Vehiculo', value: 'idDespacho.idVehiculo.placa' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    permisosRuta: {},
    despachos: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),

  components: {
    LiquidacionM
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(
    //   permiso => permiso.ruta == "Producto"
    // );
  },

  methods: {
    initialize () {
      this.listarDespacho()
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm:ss')
    },

    listarDespacho () {
      Api.get('liquidacionDespacho')
        .then(res => {
          this.despachos = res.data
          this.loading = false
          this.despachos.forEach(despacho => {
            despacho.idDespacho.fechaCarga = this.formato(despacho.idDespacho.fechaCarga)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    validarCrear () {
      return true
      // return this.permisosRuta.accion.includes("Crear");
    },

    validarModificar () {
      return true
      // return this.permisosRuta.accion.includes("Modificar");
    },

    editItem (item, bool) {
      this.editedIndex = this.despachos.indexOf(item)
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.dialog = true
      this.read = bool
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.loadinghijo = true
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.read = false
      }, 200)
    }

  }
}
</script>
<style lang="scss">
 @media screen and (max-width: 425px) {
    .head-toolbar-ldespacho, .head-toolbar-ldespacho .v-toolbar__content  {
      height: 80px !important;
    }
  }
</style>